import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Button, Flex } from "orcs-design-system";
import styled from "styled-components";
import { useUserPerson } from "src/contexts/global/GlobalContext";
import { useAIChat } from "./context/AIChatContext";
import { AGENTCORE_NAMES, ASK_TEAMFORM_MODES } from "./consts";
import { getSuggestedPrompts } from "./getSuggestedPrompts";

export const PromptButton = styled(Button)`
  background: ${(props) => props.theme.colors.surface};
  border: 1px solid ${(props) => props.theme.colors.surfaceBorder};
  color: ${(props) => props.theme.colors.bodyText};
  padding: 8px 26px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 400;
  transition: all 0.2s ease;
  width: 100%;

  &:hover {
    background: ${(props) => props.theme.colors.hoverSurface};
    border-color: ${(props) => props.theme.colors.surfaceBorder};
  }
`;

/**
 * Suggested prompt buttons for the Ask TeamForm welcome screen.
 */
const SuggestedPrompts = ({
  onPromptSelect,
  askTeamformMode: askTeamformModeProp,
  enableSupportQuestionInAskTeamform: enableSupportFlagProp,
  selectedAgent: selectedAgentProp,
}) => {
  const person = useUserPerson();
  const chatContext = useAIChat();
  const askTeamformMode =
    askTeamformModeProp ??
    chatContext.askTeamformMode ??
    ASK_TEAMFORM_MODES.DATA;
  const enableSupportQuestionInAskTeamform =
    enableSupportFlagProp ??
    chatContext.enableSupportQuestionInAskTeamform ??
    false;
  const selectedAgent =
    selectedAgentProp ??
    chatContext.selectedAgent ??
    AGENTCORE_NAMES.ASK_TEAMFORM;

  const suggestedPrompts = useMemo(
    () =>
      getSuggestedPrompts({
        askTeamformMode,
        enableSupportQuestionInAskTeamform,
        selectedAgent,
        person,
      }),
    [askTeamformMode, enableSupportQuestionInAskTeamform, selectedAgent, person]
  );

  return (
    <Flex flexDirection="column" alignItems="center" gap="r" mt="r">
      <Flex flexWrap="wrap" justifyContent="center" gap="xs" maxWidth="500px">
        {suggestedPrompts.map((prompt) => (
          <PromptButton
            key={prompt}
            variant="ghost"
            onClick={() => onPromptSelect(prompt)}
            small
            mb="r"
          >
            {prompt}
          </PromptButton>
        ))}
      </Flex>
    </Flex>
  );
};

SuggestedPrompts.propTypes = {
  onPromptSelect: PropTypes.func.isRequired,
  askTeamformMode: PropTypes.string,
  enableSupportQuestionInAskTeamform: PropTypes.bool,
  selectedAgent: PropTypes.string,
};

export default SuggestedPrompts;
